import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs"
@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private isDarkModeSubject = new BehaviorSubject<boolean>(this.getSavedTheme()); // ✅ BehaviorSubject
  isDarkMode$ = this.isDarkModeSubject.asObservable(); // ✅ Observable for components to subscribe

  constructor() {
    this.applyTheme(this.isDarkModeSubject.value); // Apply the saved theme on load
  }

  toggleTheme(): void {
    const newTheme = !this.isDarkModeSubject.value; // Toggle the value
    this.isDarkModeSubject.next(newTheme); // ✅ Update BehaviorSubject value
    localStorage.setItem('theme', newTheme ? 'dark' : 'light'); // ✅ Save in localStorage
    this.applyTheme(newTheme); // ✅ Apply the new theme
  }

  private applyTheme(isDark: boolean): void {
    document.body.className = isDark ? 'dark-theme' : 'light-theme';
  }

  private getSavedTheme(): boolean {
    return localStorage.getItem('theme') === 'dark'; // Returns `true` if dark, otherwise `false`
  }
  getCurrentTheme(): boolean {
    return this.isDarkModeSubject.value; // ✅ Use BehaviorSubject, not Observable
  }
  // getStoredTheme(): boolean {
  //   return localStorage.getItem('theme') === 'dark';
  // }
  // constructor() { }
}
